import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHead, Field, inp } from "../../components/admin/AdminBits";
import { Share2, Gift, UserPlus, Save } from "lucide-react";
import { toast } from "sonner";

export default function AdminReferrals() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then(({ data }) => setS(data)); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/admin/settings", { referral_reward_percent: s.referral_reward_percent }); toast.success("Запазено"); }
    catch { toast.error("Грешка"); }
  };

  return (
    <div data-testid="admin-referrals">
      <PageHead title="Препоръки (Refer a friend)" desc="Програма „Препоръчай приятел“ – съществуващите клиенти получават награда, когато доведат нов купувач." />
      <div className="grid md:grid-cols-3 gap-5 mb-8">
        {[
          { icon: UserPlus, t: "1. Клиентът кани приятел", d: "Всеки клиент получава личен реферален код/линк, който споделя." },
          { icon: Share2, t: "2. Приятелят купува", d: "Новият клиент използва линка и прави поръчка с отстъпка." },
          { icon: Gift, t: "3. Награда", d: "Препоръчалият получава % награда/отстъпка за следваща покупка." },
        ].map((x) => (
          <div key={x.t} className="bg-white border border-stone p-5">
            <div className="w-11 h-11 border border-gold flex items-center justify-center text-gold mb-3"><x.icon size={20} /></div>
            <h3 className="font-serif text-lg text-navy">{x.t}</h3>
            <p className="text-sm text-charcoal/60 mt-1">{x.d}</p>
          </div>
        ))}
      </div>
      <div className="bg-white border border-stone p-6 max-w-md">
        <h2 className="font-serif text-xl text-navy mb-2">Настройка</h2>
        <p className="text-sm text-charcoal/55 mb-4">Реферална система използва механиката на „Афилиейт линкове" – създайте партньорски код за всеки клиент в менюто <b>Афилиейт линкове</b>. Тук задавате стандартния процент награда.</p>
        {s && (
          <form onSubmit={save}>
            <Field label="Награда за препоръка (%)"><input type="number" value={s.referral_reward_percent || 0} onChange={(e) => setS({ ...s, referral_reward_percent: parseFloat(e.target.value) || 0 })} className={inp} data-testid="referral-percent" /></Field>
            <button type="submit" className="btn-gold px-5 py-2.5 rounded-sm flex items-center gap-2 text-sm" data-testid="save-referral-btn"><Save size={15} /> Запази</button>
          </form>
        )}
      </div>
    </div>
  );
}
